export {
    DESKTOP_VERSION_SELECTOR,
    HeaderObject,
    HeaderType,
    ICachedComponentsRegistry,
    IComponent,
    IComponentRegistry,
    IComponentViewController,
    IHttpTransport,
    IServiceRegistryComponent,
    isWebRendered,
    IUtag,
    IUtagCfgOvrd,
    IUtagData,
    IViewControllerData,
    MOBILE_VERSION_SELECTOR,
    RegisteredComponent,
    root,
    SERVICE_VIEW_CLASSNAME,
    SERVICE_VIEW_RENDERED_ATTRIBUTE,
    ViewControllerLoadedMethod
} from './UniversalUtils';

export { BrowserStorage } from './BrowserStorage';
